/**
 * Cifras con tipografía contable (módulo Tesorería).
 *
 * `<Monto>` y `<Num>` envuelven la cifra en un <span class="num"> que aplica
 * la fuente monoespaciada tabular (IBM Plex Mono). El tamaño, color y peso
 * los hereda del elemento contenedor — `.num` solo cambia la familia y el
 * `font-variant-numeric`, así que componen con las clases existentes.
 *
 * Uso:
 *   <Monto value={1234567} />              → "$1.234.567" monoespaciado
 *   <Num>{count}</Num>                     → conteos / códigos
 *   <Num>{`${pct} %`}</Num>                → porcentajes
 *
 * `formatCLP` (lib/format) NO se toca: es compartido con otros módulos y
 * sigue devolviendo string. Aquí solo se envuelve su resultado.
 */
import type { ReactNode } from 'react';
import { formatCLP } from '../../lib/format';

interface MontoProps {
  value: number;
  /** Clases extra (color, tamaño, etc.) que se suman a `.num`. */
  className?: string;
}

export function Monto({ value, className }: MontoProps) {
  return (
    <span className={className ? `num ${className}` : 'num'}>
      {formatCLP(value)}
    </span>
  );
}

interface NumProps {
  children: ReactNode;
  className?: string;
}

/** Envoltura contable para cifras que no son montos CLP (conteos, %, códigos). */
export function Num({ children, className }: NumProps) {
  return (
    <span className={className ? `num ${className}` : 'num'}>{children}</span>
  );
}
